import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Form } from 'antd';
import { updateCurrencies } from '../../../../../services/currencies/currenciesApi';
import { toast } from 'react-toastify';
// Ensure this API function is defined

const UpdateCurrencies = ({ isOpen, onClose, currencie, onUpdate }) => {
    const [coins, setCoins] = useState(0);
    const [amount, setAmount] = useState(0);

    const handleUpdate = async () => {
        const response = await updateCurrencies({ coins: coins * 1000, amount: amount , id: currencie.id});
        if (response.data.errors) {
            toast.error("Failed to update currencies");

        } else {
            toast.success("Currencies updated successfully");
            onClose();
            onUpdate();
        }
    }

    useEffect(() => {
        setCoins(currencie?.coins / 1000);
        setAmount(currencie?.amount);
    }, [currencie]);

    return (
        <Modal
            title="Update Currencies"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleUpdate} >
                    Update
                </Button>,
            ]}
        >
            <Form layout="vertical">

                <label style={{ color: 'var(--primary-color3)' }} htmlFor="amount">Amount</label>
                <div className="input-group border rounded-3">
                    <input type="number" id="amount" name="amount" required placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} className='form-control' />
                    <div className="input-group-append">
                        <span className="input-group-text">USD</span>
                    </div>
                </div>



                <label  style={{ color: 'var(--primary-color3)' }} htmlFor="coins">Coins</label>
                <div className="input-group border rounded-3">
                    <input  type="number" id="coins" name="coins" required placeholder="Coins" value={coins} onChange={(e) => setCoins(e.target.value)} className='form-control' />
                    <div className="input-group-append">
                        <span className="input-group-text">K</span>
                    </div>
                </div>


            </Form>
        </Modal>
    );
};

export default UpdateCurrencies; 